<template>
  <div id="console">
    <div @click="close" id="close-button">
      <p>X</p>
    </div>
    <div @click="toggle" id="toggle-button">
      <p>-</p>
    </div>
    <h6 @click="toggle">Console</h6>
    <div v-if="visible" id="console-content" ref="content">
      <div v-if="https">
        <p
          v-for="(log, index) in logs"
          :key="index"
          :class="log.type==0?'info':log.type==1?'warning':log.type==2?'error':'success'"
        >{{log.message}}</p>
        <br />
        <br />
      </div>
      <div v-else>
        <p class="warning">La console est uniquement accessible en HTTPS (<a :href="`https://${host}`">https://{{host}}</a>)</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from "@/auth";
import api from "@/api";

export default {
  data() {
    return {
      logs: [],
      https: true,
      visible: true,
      host: process.env.VUE_APP_HOST
    };
  },
  async created() {
    this.https = document.location.protocol.indexOf("https") !== -1;
    if (this.https) {
      this.logs = (await api.getLastLogs()).data;
      this.$socket.send(getAccessToken());
      this.$options.sockets.onmessage = message => {
        this.logs.push(JSON.parse(message.data));
        this.$refs.content.scrollTop = 99999999;
      };
    }
  },
  methods: {
    close: function() {
      this.$store.commit("setConsole", false);
      this.$cookies.set("console", false);
    },
    toggle: async function() {
      await (this.visible = !this.visible);
      this.$refs.content.scrollTop = 99999999;
    }
  }
};
</script>